<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="wrapper wrapper-content animated fadeInUp">
                    <div class="ibox">
                        <div class="ibox-title">
                            <h5>Export sites</h5>
                        </div>
                        <div class="ibox-content">
                            <div class="row m-b-sm m-t-sm">
                                <div class="col-lg-4">
                                    <select name="language" id="iTag" class="col-lg-8" ref="tag">
                                        <option value="0">No Tag</option>
                                        <option value="1">General</option>
                                        <option value="2">High Authority</option>
                                        <option value="3">Tier2</option>
                                        <option value="4">ScrapYard</option>
                                    </select>
                                </div>
                                <div class="col-lg-6">
                                    <button @click="exportTags">Export</button>
                                </div>
                            </div>
                            <div class="row m-b-sm m-t-sm">
                                <div class="col-lg-4">
                                    <input type="file" name="" ref="file" id="">
                                </div>
                                <div class="col-lg-6">
                                    <button @click="importTags">Import</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      some: 'thing'
    }
  },
  methods: {
    forceFileDownload (data) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'sites.txt')
      document.body.appendChild(link)
      link.click()
    },
    exportTags () {
      let tag = this.$refs.tag.value
      axios.get('/sites/tag-export/' + tag)
        .then(r => {
          let resp = ''
          r.data.forEach(url => {
            resp += url + '\n'
          })
          this.forceFileDownload(resp)
        })
        .catch(e => {
          this.$swal({
            type: 'warning',
            title: 'No sites',
            text: 'No sites with tag ' + tag + ' found'
          })
        })
    },
    importTags () {
      let formData = new FormData()
      console.log(this.$refs.file.files[0])
      formData.append('tags', this.$refs.file.files[0])
      axios.post('/sites/tag-import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(r => {
          this.$swal({
            type: 'success',
            title: 'Sorted',
            text: 'Updated ' + r.data.count + ' sites'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Sites/Tags.vue